import { render, staticRenderFns } from "./UploadImagePayment.vue?vue&type=template&id=a0cc72f6&"
import script from "./UploadImagePayment.vue?vue&type=script&lang=js&"
export * from "./UploadImagePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports